export const FETCH_ICONS = "FETCH_ICONS";
export const FETCH_ICONS_SUCCESS = "FETCH_ICONS_SUCCESS";
export const FETCH_ICONS_FAILED = "FETCH_ICONS_FAILED";
export const FETCH_FONTAWESOME_ICONS = "FETCH_FONTAWESOME_ICONS";
export const FETCH_FONTAWESOME_ICONS_SUCCESS =
  "FETCH_FONTAWESOME_ICONS_SUCCESS";
export const FETCH_FONTAWESOME_ICONS_FAILED = "FETCH_FONTAWESOME_ICONS_FAILED";
